import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { BusyService } from './shared/busy.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {

    constructor(private busyService: BusyService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add withCredentials to ensure that auth cookies are sent on CORS requests
        request = request.clone({
            withCredentials: true
        });

        // Not needed for now but can be used to indicate when busy state should be allowed.
        // exclude background requests from busy indicator
        // const shouldBusy = !request.url.includes('KeepAlive') && !request.url.includes('sentry');

        
        return next.handle(request);
          
    }
}
